module.exports = __webpack_public_path__ + "img/2.823f0c.png";